/* eslint-disable eqeqeq */
import {
  ADD_INFOCARDS,
  ADD_RAIL_CHAINS,
  DELETE_RAIL_CHAINS,
  EDIT_INFOCARD,
  EDIT_RAIL_CHAINS,
  INIT_INFOCARDS,
  INIT_RAIL_CHAINS,
  INIT_ADJACENCY,
  DELETE_ADJACENCY,
  INIT_SEMAPHORES,
  DELETE_SEMAPHORE,
  ADD_SEMAPHORE,
  EDIT_SEMAPHORE,
  DELETE_INFOCARDS,
  ADD_ADJACENCY,
  SET_ADJACENCY,
  CLEAR_ADJACENCY_STATE,
  CLEAR_RAIL_CHAINS_STATE,
  CLEAR_SEMAPHORES_STATE,
  EDIT_MODE,
  CLEAR_INFOCARDS,
} from '../type';

export default function infocardReducer(state = {}, action) {
  const { type, payload } = action;

  switch (type) {
    case INIT_INFOCARDS: {
      // Добавляем элементы к существующему состоянию
      return {
        ...state,
        items: [...(state.items || []), ...payload],
      };
    }

    case ADD_INFOCARDS:
      return { ...state, items: [...state.items, ...payload] };

    case EDIT_INFOCARD: {
      const updatedItems = state.items.map((item) => {
        if (item.stationId === payload.stationId) {
          return { ...item, ...payload }; // Обновляем элемент
        }
        return item; // Оставляем элемент без изменений
      });

      // Возвращаем обновлённое состояние
      return {
        ...state,
        items: updatedItems,
      };
    }

    case DELETE_INFOCARDS: {
      const items = state.items.filter((x) => !payload.some((key) => key == x.stationId));
      return {
        ...state,
        items,
      };
    }

    case CLEAR_INFOCARDS: {
      return { ...state, items: payload };
    }

    case EDIT_MODE: {
      const items = [...state.items]; // Создаём копию массива
      const index = items.findIndex((item) => item.stationId === payload?.stationId);

      if (index !== -1) {
        items[index] = { ...items[index], isDisabled: payload?.isDisabled }; // Обновляем только нужный объект
      }

      return {
        ...state,
        items,
      };
    }

    case INIT_RAIL_CHAINS:
      return { ...state, railChains: payload };

    case EDIT_RAIL_CHAINS: {
      const { railChains: incomingRailChains } = payload;

      // Создаем объект с ключом id для быстрого поиска
      const incomingMap = incomingRailChains?.reduce((acc, rail) => {
        acc[rail.id] = rail;
        return acc;
      }, {});

      // Обновляем railChains с учетом изменений
      const updatedRailChains = state.railChains.map((rail) => incomingMap[rail.id] || rail);

      return {
        ...state,
        railChains: updatedRailChains,
      };
    }

    case DELETE_RAIL_CHAINS: {
      const { id } = payload;
      return {
        ...state,
        railChains: state.railChains.filter((railChain) => railChain.id !== id),
      };
    }

    case ADD_RAIL_CHAINS: {
      return {
        ...state,
        railChains: [...state.railChains, payload.rail],
      };
    }

    case CLEAR_RAIL_CHAINS_STATE:
      return { ...state, railChains: payload };

    case INIT_ADJACENCY:
      return {
        ...state,
        adjacency: payload,
      };

    case ADD_ADJACENCY: {
      return {
        ...state,
        adjacency: [...state.adjacency, ...payload],
      };
    }

    case DELETE_ADJACENCY: {
      const railChainId = Number(payload);

      const index = state.adjacency.findIndex((item) => Number(item.railChain) === railChainId);

      if (index === -1) return state;

      const updatedAdjacency = [...state.adjacency];
      updatedAdjacency[index] = {
        ...updatedAdjacency[index],
        adjacency: null,
      };

      return {
        ...state,
        adjacency: updatedAdjacency,
      };
    }

    case SET_ADJACENCY: {
      const { railChain } = payload;
      const index = state.adjacency.findIndex((item) => item.railChain === railChain);
      if (index === -1) {
        return state;
      }
      const updatedAdjacency = [...state.adjacency];
      updatedAdjacency[index] = payload;

      return {
        ...state,
        adjacency: updatedAdjacency,
      };
    }

    case CLEAR_ADJACENCY_STATE:
      return {
        ...state,
        adjacency: payload,
      };

    case INIT_SEMAPHORES: {
      return {
        ...state,
        semaphores: payload,
      };
    }

    case DELETE_SEMAPHORE: {
      return {
        ...state,
        semaphores: state.semaphores.filter((semaphore) => semaphore.semaphoreId !== payload),
      };
    }

    case ADD_SEMAPHORE: {
      return {
        ...state,
        semaphores: [payload, ...state.semaphores],
      };
    }

    case EDIT_SEMAPHORE: {
      const semaphores = state.semaphores.map((semaphore) =>
        semaphore?.semaphoreId === payload?.semaphoreId ? payload : semaphore
      );

      return {
        ...state,
        semaphores,
      };
    }

    case CLEAR_SEMAPHORES_STATE: {
      return {
        ...state,
        semaphores: payload,
      };
    }

    default:
      return state;
  }
}
